import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Layers } from '@helpers/layers';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
import { VideoCard, VideoInner } from '../VideoEmbed/VideoEmbed.styles';
const Container = styled.section `
  --bgColor: transparent;
  --fgColor: ${brand.white};
  --tintColor: rgba(0, 0, 0, 0.7);
  --buttonSize: ${fluid(18, 35)};
  --gutter: 75px;

  &[data-internal-close='true'] {
    --buttonSize: ${fluid(24, 32)};
  }

  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  color: var(--fgColor);
  height: 100%;
  place-content: center;
  place-items: center;
  width: 100%;
  z-index: ${Layers.Modal};

  &[data-open='false'] {
    display: none;
  }
`;
const Inner = styled.div `
  position: relative;

  @media ${from(Device.TabletLarge)} {
    margin: var(--gutter) 0;

    > video,
    > img {
      max-height: calc(100vh - (var(--gutter) * 2));
    }
  }

  ${VideoInner} {
    border-radius: 0;
    overflow: visible;
  }

  ${VideoCard} {
    min-width: 85vw;

    @media ${from(Device.TabletLarge)} {
      min-width: 854px;
    }
  }
`;
const ModalStyles = {
    Container,
    Inner,
};
export default ModalStyles;
